import { memo } from "react";
import { Stack, TextField } from "@mui/material";
import { TUserFullInfo } from "../../models";
import { AccordionShell } from "./AccordionShell";

export type UserInformationFallbackProps = {
  userInfo: TUserFullInfo;
  isMobile: boolean;
  companyRole: string;
  comments: Record<string, string>;
  addComment: (userDocumentId: string, comment: string) => void;
};

export const UserInformationFallback = memo(
  (props: UserInformationFallbackProps) => {
    const { userInfo, isMobile, companyRole, comments, addComment } = props;

    return (
      <AccordionShell
        title="User Information"
        companyRole={companyRole}
        comments={comments}
        addComment={addComment}
      >
        <Stack
          direction={isMobile ? "column" : "row"}
          spacing={2}
          sx={{ marginBottom: 1 }}
        >
          <TextField
            fullWidth
            value={userInfo.phone}
            label="Phone number"
            inputProps={{ disabled: true }}
          />
          <TextField
            fullWidth
            value={userInfo.email}
            label="Email"
            inputProps={{ disabled: true }}
          />
          <TextField
            fullWidth
            value={userInfo.externalEmail}
            label="External system email"
            inputProps={{ disabled: true }}
          />
        </Stack>
      </AccordionShell>
    );
  }
);
